import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { JwtHelperService } from '@auth0/angular-jwt';
@Injectable({
  providedIn: 'root'
})
export class TokenGuardService  {

  constructor(private router: Router, private jwtHelper: JwtHelperService) { }
  canActivate(): boolean {
    if (this.isAuthenticated()) {
      return true;
    } else {
      localStorage.clear();
      sessionStorage.clear();
      this.router.navigate(['user-authentication']);
      return false;
    }
  }

  isAuthenticated(): boolean {
    const token: any = localStorage.getItem('token')?.toString();
    return !this.jwtHelper.isTokenExpired(token);
  }
}
